module.exports = `${require.publicPath}logo.f318e3be.png`;